import { VisitPractitioner as VisitPractitionerAPI } from '@dreryk/egabinet-visit-frontend-api';

import { AutoLayout, IconFillColor, IconWrapper, StethoscopeIcon } from '@dreryk/react-components';

import { PractitionerSafePresenter } from '~libs.desktop.shared.practitioner-safe-presenter';

type VisitPractitionerProps = {
   readonly practitioner: VisitPractitionerAPI;
};

export const VisitPractitioner = (props: VisitPractitionerProps): JSX.Element => {
   return (
      <AutoLayout as={'div'} $spacing={4} $alignement={'center'} $horizontalResizing={'hug'}>
         <IconWrapper testId={'clock'} fillColor={IconFillColor.BACKGROUND}>
            <StethoscopeIcon />
         </IconWrapper>
         <PractitionerSafePresenter
            testId={'practitioner'}
            practitioner={props.practitioner}
            type={'text'}
            withIdentification
         />
      </AutoLayout>
   );
};
